import type { Skill } from '../skillsData';

export const cryptoskillData: Skill[] = [
  // ===== DEX / DeFi =====
  {
    id: 'aerodrome-dex',
    name: 'aerodrome-dex',
    author: 'Aerodrome',
    authorHandle: '@aerodromefi',
    tag: 'Skill',
    category: 'defi',
    description: 'Interact with Aerodrome DEX on Base. Swap tokens, add liquidity, manage veAERO positions, and vote on gauge rewards.',
    downloads: 32400,
    stars: 1560,
    version: '2.1.0',
    installCommand: '> install the aerodrome-dex skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dex/aerodrome-dex',
    usageExample: '> swap USDC for AERO\n> add liquidity to AERO-USDC pool\n> vote on gauge rewards',
    detailedDescription: 'Full Aerodrome DEX integration for Base. Execute token swaps, manage concentrated liquidity positions, lock AERO for veAERO voting power, and participate in gauge voting for protocol emissions.',
    featured: true,
    trending: true,
  },
  {
    id: 'cow-protocol',
    name: 'cow-protocol',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'MEV-protected DEX aggregation via CoW Protocol. Batch auctions, intent-based trading, and surplus capture across Ethereum and L2s.',
    downloads: 21800,
    stars: 980,
    version: '1.5.0',
    installCommand: '> install the cow-protocol skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dex/cow-protocol',
    usageExample: '> submit trade intent\n> get batch auction quote\n> execute MEV-protected swap',
    detailedDescription: 'CoW Protocol integration enabling MEV-protected decentralized trading through batch auctions. Submit trade intents, receive surplus-capturing quotes, and execute across Ethereum, Base, Arbitrum, and Gnosis Chain.',
    featured: true,
  },
  {
    id: 'crypto-aave',
    name: 'aave',
    author: 'Aave',
    authorHandle: '@aave',
    tag: 'Skill',
    category: 'defi',
    description: 'Lend, borrow, and manage positions across Aave V3 markets on Ethereum, Base, Arbitrum, Polygon, and Optimism.',
    downloads: 45600,
    stars: 2100,
    version: '3.2.0',
    installCommand: '> install the aave skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/aave',
    usageExample: '> supply USDC to Aave\n> borrow ETH against collateral\n> monitor health factor',
    detailedDescription: 'Complete Aave V3 DeFi integration. Supply assets to earn yield, borrow against collateral with variable or stable rates, manage health factors, and execute liquidations across all supported L1 and L2 markets.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-lifi-bridge',
    name: 'lifi-bridge',
    author: 'LI.FI',
    authorHandle: '@lifiprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Cross-chain bridging and swapping via LI.FI aggregation. Route assets across 20+ chains with optimal path finding.',
    downloads: 18700,
    stars: 840,
    version: '2.3.0',
    installCommand: '> install the lifi-bridge skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lifi-bridge',
    usageExample: '> bridge USDC from Ethereum to Base\n> find optimal cross-chain route\n> execute swap-and-bridge',
    detailedDescription: 'LI.FI cross-chain infrastructure aggregation. Bridge and swap assets across 20+ EVM and non-EVM chains with intelligent routing through bridges, DEXs, and solvers for optimal speed and cost.',
    trending: true,
  },
  {
    id: 'crypto-lifi-bridge-agent',
    name: 'lifi-bridge-agent',
    author: 'LI.FI',
    authorHandle: '@lifiprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Agent-optimized cross-chain bridging with automated rebalancing and multi-hop route execution.',
    downloads: 9200,
    stars: 410,
    version: '1.1.0',
    installCommand: '> install the lifi-bridge-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lifi-bridge-agent',
    usageExample: '> auto-rebalance across chains\n> execute multi-hop bridge route\n> monitor bridge status',
    detailedDescription: 'Agent-native cross-chain bridging with automated rebalancing logic, multi-hop route execution, and real-time bridge status monitoring for autonomous treasury management.',
  },
  {
    id: 'crypto-lifi-bridge-router',
    name: 'lifi-bridge-router',
    author: 'LI.FI',
    authorHandle: '@lifiprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Advanced routing engine for LI.FI cross-chain transactions. Custom route preferences, slippage controls, and fallback paths.',
    downloads: 7600,
    stars: 340,
    version: '1.2.0',
    installCommand: '> install the lifi-bridge-router skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lifi-bridge-router',
    usageExample: '> set custom route preferences\n> configure slippage tolerance\n> execute with fallback paths',
    detailedDescription: 'Advanced routing engine for LI.FI transactions with granular control over bridge preferences, slippage tolerances, solver selection, and automatic fallback path execution.',
  },
  {
    id: 'crypto-lifi-cross-chain-bridge',
    name: 'lifi-cross-chain-bridge',
    author: 'LI.FI',
    authorHandle: '@lifiprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Simplified cross-chain bridging abstraction. One-command bridge execution with automatic chain detection.',
    downloads: 6500,
    stars: 290,
    version: '1.0.0',
    installCommand: '> install the lifi-cross-chain-bridge skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lifi-cross-chain-bridge',
    usageExample: '> bridge to Base\n> auto-detect destination chain\n> one-click cross-chain transfer',
    detailedDescription: 'Simplified cross-chain bridging with automatic source/destination chain detection, one-command execution, and built-in confirmation tracking across all LI.FI supported networks.',
  },
  {
    id: 'crypto-cardano-staking',
    name: 'cardano-staking',
    author: 'Cardano',
    authorHandle: '@cardano',
    tag: 'Skill',
    category: 'defi',
    description: 'Stake ADA, manage delegation pools, claim rewards, and track staking performance on Cardano.',
    downloads: 12400,
    stars: 580,
    version: '1.4.0',
    installCommand: '> install the cardano-staking skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/cardano-staking',
    usageExample: '> delegate ADA to pool\n> claim staking rewards\n> track staking ROI',
    detailedDescription: 'Full Cardano staking management. Delegate ADA to stake pools, claim epoch rewards, compare pool performance metrics, and track historical staking returns.',
  },
  {
    id: 'crypto-hedera-token-mint',
    name: 'hedera-token-mint',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'defi',
    description: 'Mint fungible and non-fungible tokens on Hedera Hashgraph. HTS token creation, supply management, and custom fees.',
    downloads: 5800,
    stars: 260,
    version: '1.0.2',
    installCommand: '> install the hedera-token-mint skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/hedera-token-mint',
    usageExample: '> mint fungible token on Hedera\n> create NFT collection\n> configure custom fees',
    detailedDescription: 'Hedera Token Service (HTS) integration for creating and managing fungible and non-fungible tokens with custom fee schedules, supply key management, and automatic association.',
  },
  {
    id: 'crypto-darwin-fi',
    name: 'darwin-fi',
    author: 'DarwinFi',
    authorHandle: '@darwinfi',
    tag: 'Skill',
    category: 'defi',
    description: 'Evolutionary DeFi strategies. Auto-adaptive yield farming with fitness-based strategy selection and mutation.',
    downloads: 3400,
    stars: 150,
    version: '0.8.0',
    installCommand: '> install the darwin-fi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/darwin-fi',
    usageExample: '> evolve yield strategy\n> select fittest farming pool\n> auto-mutate allocation',
    detailedDescription: 'Evolutionary algorithm-powered DeFi strategy optimization. Strategies compete for fitness based on yield, automatically mutate parameters, and propagate successful traits across generations.',
  },
  {
    id: 'crypto-drift-trader',
    name: 'drift-trader',
    author: 'Drift Protocol',
    authorHandle: '@driftprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'Perpetual futures and spot trading on Drift Protocol (Solana). Leveraged positions, insurance fund staking, and LP vaults.',
    downloads: 15600,
    stars: 720,
    version: '2.0.0',
    installCommand: '> install the drift-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/drift-trader',
    usageExample: '> open perp position on SOL\n> deposit into LP vault\n> stake in insurance fund',
    detailedDescription: 'Drift Protocol integration for Solana. Trade perpetual futures with up to 20x leverage, provide liquidity to spot and perp LP vaults, and stake in the insurance fund for protocol revenue share.',
    trending: true,
  },
  {
    id: 'crypto-bridge-agent-crosschain',
    name: 'bridge-agent-crosschain',
    author: 'CrossChain Labs',
    authorHandle: '@crosschainlabs',
    tag: 'Skill',
    category: 'defi',
    description: 'Autonomous cross-chain bridge agent. Monitors opportunities, executes bridges, and rebalances across networks.',
    downloads: 4200,
    stars: 190,
    version: '1.0.1',
    installCommand: '> install the bridge-agent-crosschain skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bridge-agent-crosschain',
    usageExample: '> monitor cross-chain arb\n> auto-execute bridge\n> rebalance treasury across chains',
    detailedDescription: 'Autonomous bridge agent that monitors yield differentials and arbitrage opportunities across chains, executes optimal bridge transactions, and maintains treasury balance across networks.',
  },

  // ===== Blockchain Infrastructure / Tools =====
  {
    id: 'aptos-official-agent-skills',
    name: 'aptos-official-agent-skills',
    author: 'Aptos Labs',
    authorHandle: '@aptoslabs',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Aptos agent toolkit. On-chain transactions, Move module interaction, NFT operations, and account management.',
    downloads: 21500,
    stars: 980,
    version: '1.3.0',
    installCommand: '> install the aptos-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/aptos-official-agent-skills',
    usageExample: '> interact with Move module\n> mint Aptos NFT\n> manage resource accounts',
    detailedDescription: 'Official Aptos Labs agent skills for interacting with the Aptos blockchain. Execute transactions, call Move modules, manage NFTs and tokens, and handle resource account operations.',
    featured: true,
  },
  {
    id: 'aptos-official-agent',
    name: 'aptos-official-agent',
    author: 'Aptos Labs',
    authorHandle: '@aptoslabs',
    tag: 'Skill',
    category: 'tools',
    description: 'Aptos agent core. Account creation, transaction signing, event monitoring, and REST API access for the Aptos network.',
    downloads: 18200,
    stars: 820,
    version: '1.2.0',
    installCommand: '> install the aptos-official-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/aptos-official-agent',
    usageExample: '> create Aptos account\n> sign transaction\n> monitor on-chain events',
    detailedDescription: 'Core Aptos blockchain agent functionality. Create and manage accounts, sign and submit transactions, monitor real-time on-chain events, and query the Aptos REST API.',
  },
  {
    id: 'crypto-arbitrum',
    name: 'arbitrum',
    author: 'Arbitrum',
    authorHandle: '@arbitrum',
    tag: 'Skill',
    category: 'tools',
    description: 'Arbitrum L2 operations. Bridge to/from Ethereum, interact with Arbitrum Nova, and manage retryable tickets.',
    downloads: 28900,
    stars: 1340,
    version: '2.1.0',
    installCommand: '> install the arbitrum skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/arbitrum',
    usageExample: '> bridge ETH to Arbitrum One\n> interact with Arbitrum Nova\n> manage retryable tickets',
    detailedDescription: 'Full Arbitrum L2 integration. Bridge assets between Ethereum and Arbitrum One/Nova, interact with L2 contracts, manage retryable tickets, and query ArbSys precompile.',
  },
  {
    id: 'crypto-arbitrum-dapp',
    name: 'arbitrum-dapp',
    author: 'Arbitrum',
    authorHandle: '@arbitrum',
    tag: 'Skill',
    category: 'tools',
    description: 'DApp development toolkit for Arbitrum. Contract deployment, Stylus integration, and Orbit chain configuration.',
    downloads: 7600,
    stars: 350,
    version: '1.0.2',
    installCommand: '> install the arbitrum-dapp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/arbitrum-dapp',
    usageExample: '> deploy contract on Arbitrum\n> configure Stylus\n> set up Orbit chain',
    detailedDescription: 'Arbitrum DApp development toolkit. Deploy and interact with smart contracts, integrate with Arbitrum Stylus for Rust/C++ contracts, and configure custom Orbit chains.',
  },
  {
    id: 'crypto-avalanche',
    name: 'avalanche',
    author: 'Avalanche',
    authorHandle: '@avalancheavax',
    tag: 'Skill',
    category: 'tools',
    description: 'Avalanche C-Chain and Subnet operations. P-Chain staking, X-Chain transfers, and custom Subnet deployment.',
    downloads: 19800,
    stars: 920,
    version: '2.0.0',
    installCommand: '> install the avalanche skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/avalanche',
    usageExample: '> stake AVAX on P-Chain\n> transfer assets on X-Chain\n> deploy custom Subnet',
    detailedDescription: 'Complete Avalanche network integration. Operate on C-Chain for smart contracts, stake AVAX on P-Chain, manage X-Chain asset transfers, and deploy/configure custom Subnets.',
    featured: true,
  },
  {
    id: 'crypto-avalanche-avabuilder',
    name: 'avalanche-avabuilder',
    author: 'Ava Labs',
    authorHandle: '@avalabs',
    tag: 'Skill',
    category: 'tools',
    description: 'AvaBuilder toolkit for Avalanche Subnet creation. Validator setup, custom VM deployment, and subnet economics.',
    downloads: 5400,
    stars: 240,
    version: '1.1.0',
    installCommand: '> install the avalanche-avabuilder skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/avalanche-avabuilder',
    usageExample: '> create new Subnet\n> deploy custom VM\n> configure subnet economics',
    detailedDescription: 'AvaBuilder toolkit for creating and managing Avalanche Subnets. Set up validators, deploy custom virtual machines, configure subnet token economics, and manage inter-subnet communication.',
  },
  {
    id: 'base-agent-starter',
    name: 'base-agent-starter',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Starter template for building agents on Base. Wallet setup, onchain interactions, and CDP integration.',
    downloads: 32400,
    stars: 1560,
    version: '1.0.0',
    installCommand: '> install the base-agent-starter skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-agent-starter',
    usageExample: '> initialize Base agent\n> setup wallet with CDP\n> execute first onchain tx',
    detailedDescription: 'Official Coinbase starter template for building on-chain agents on Base. Includes wallet setup via Coinbase Developer Platform, sample on-chain interactions, and deployment scaffolding.',
    featured: true,
    trending: true,
  },
  {
    id: 'base-official-adding-builder-codes',
    name: 'base-official-adding-builder-codes',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Add builder codes and attribution to Base transactions. Track agent contributions and builder reputation.',
    downloads: 8700,
    stars: 390,
    version: '1.0.0',
    installCommand: '> install the base-official-adding-builder-codes skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-adding-builder-codes',
    usageExample: '> add builder code to tx\n> track agent contributions\n> query builder reputation',
    detailedDescription: 'Base builder code attribution system. Add builder codes to transactions for contribution tracking, query builder reputation scores, and manage agent attribution metadata.',
  },
  {
    id: 'base-official-building-with-base-account',
    name: 'base-official-building-with-base-account',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Build with Base Account abstraction. Smart account creation, session keys, and gasless transactions.',
    downloads: 11200,
    stars: 510,
    version: '1.0.0',
    installCommand: '> install the base-official-building-with-base-account skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-building-with-base-account',
    usageExample: '> create smart account\n> setup session keys\n> execute gasless tx',
    detailedDescription: 'Base Account Abstraction toolkit. Create ERC-4337 smart accounts, manage session keys for automated operations, and execute gasless transactions with paymaster integration.',
  },
  {
    id: 'base-official-connecting-to-base-network',
    name: 'base-official-connecting-to-base-network',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Connect agents to Base network. RPC configuration, chain ID detection, and network health monitoring.',
    downloads: 15600,
    stars: 720,
    version: '1.0.0',
    installCommand: '> install the base-official-connecting-to-base-network skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-connecting-to-base-network',
    usageExample: '> connect to Base mainnet\n> detect chain ID\n> monitor network health',
    detailedDescription: 'Base network connection management. Configure RPC endpoints, detect chain IDs across Base mainnet and testnet, monitor network health metrics, and handle connection fallbacks.',
  },
  {
    id: 'base-official-convert-farcaster-miniapp-to-app',
    name: 'base-official-convert-farcaster-miniapp-to-app',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Convert Farcaster Mini Apps to standalone applications with Base integration. Frame-to-app migration toolkit.',
    downloads: 6800,
    stars: 310,
    version: '1.0.0',
    installCommand: '> install the base-official-convert-farcaster-miniapp-to-app skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-convert-farcaster-miniapp-to-app',
    usageExample: '> convert mini app to app\n> migrate frame to standalone\n> integrate Base wallet',
    detailedDescription: 'Farcaster Mini App to standalone application converter. Migrate frame-based experiences to full apps with native Base wallet integration, on-chain actions, and improved UX.',
  },
  {
    id: 'base-official-converting-minikit-to-farcaster',
    name: 'base-official-converting-minikit-to-farcaster',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Convert Coinbase MiniKit apps to Farcaster Frames. Cross-platform compatibility and shared state management.',
    downloads: 5900,
    stars: 270,
    version: '1.0.0',
    installCommand: '> install the base-official-converting-minikit-to-farcaster skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-converting-minikit-to-farcaster',
    usageExample: '> convert MiniKit to Frame\n> manage shared state\n> deploy to Farcaster',
    detailedDescription: 'MiniKit to Farcaster Frame conversion toolkit. Transform Coinbase MiniKit applications into Farcaster-compatible frames with shared state management and cross-platform deployment.',
  },
  {
    id: 'base-official-deploying-contracts-on-base',
    name: 'base-official-deploying-contracts-on-base',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Deploy smart contracts on Base L2. Compilation, verification, and CDP-backed deployment pipeline.',
    downloads: 18700,
    stars: 850,
    version: '1.0.0',
    installCommand: '> install the base-official-deploying-contracts-on-base skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-deploying-contracts-on-base',
    usageExample: '> compile Solidity contract\n> deploy to Base\n> verify on Basescan',
    detailedDescription: 'Smart contract deployment pipeline for Base. Compile Solidity/Vyper contracts, deploy via Coinbase Developer Platform, verify on Basescan, and manage deployment artifacts.',
  },
  {
    id: 'base-official-migrating-an-onchainkit-app',
    name: 'base-official-migrating-an-onchainkit-app',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Migrate OnchainKit applications to latest version. Dependency updates, breaking change resolution, and feature migration.',
    downloads: 7200,
    stars: 330,
    version: '1.0.0',
    installCommand: '> install the base-official-migrating-an-onchainkit-app skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-migrating-an-onchainkit-app',
    usageExample: '> migrate OnchainKit app\n> resolve breaking changes\n> update dependencies',
    detailedDescription: 'OnchainKit migration assistant. Automatically update OnchainKit dependencies, resolve breaking changes between versions, and migrate deprecated features to current APIs.',
  },
  {
    id: 'base-official-registering-agent-base-dev',
    name: 'base-official-registering-agent-base-dev',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Register agents with Base Developer Platform. API key management, webhook configuration, and usage analytics.',
    downloads: 9400,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the base-official-registering-agent-base-dev skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-registering-agent-base-dev',
    usageExample: '> register agent with CDP\n> configure webhooks\n> view usage analytics',
    detailedDescription: 'Base Developer Platform agent registration. Manage API keys, configure webhooks for real-time updates, track usage analytics, and manage agent permissions on Coinbase Developer Platform.',
  },
  {
    id: 'base-official-running-a-base-node',
    name: 'base-official-running-a-base-node',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Run a Base node. OP Stack configuration, sequencer sync, and validator setup for Base mainnet and testnet.',
    downloads: 11200,
    stars: 520,
    version: '1.0.0',
    installCommand: '> install the base-official-running-a-base-node skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base-official-running-a-base-node',
    usageExample: '> start Base node\n> sync with sequencer\n> run validator',
    detailedDescription: 'Base node operation toolkit. Configure and run OP Stack nodes, sync with the Base sequencer, set up validation nodes, and manage node infrastructure for both mainnet and testnet.',
  },
  {
    id: 'crypto-bitcoin',
    name: 'bitcoin',
    author: 'Bitcoin',
    authorHandle: '@bitcoin',
    tag: 'Skill',
    category: 'tools',
    description: 'Bitcoin network operations. Transaction building, mempool monitoring, and Lightning Network channel management.',
    downloads: 42100,
    stars: 2150,
    version: '2.5.0',
    installCommand: '> install the bitcoin skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bitcoin',
    usageExample: '> build Bitcoin tx\n> monitor mempool\n> manage Lightning channel',
    detailedDescription: 'Bitcoin network integration. Build and broadcast transactions, monitor mempool dynamics, manage Lightning Network channels, and query UTXO sets via RPC or esplora APIs.',
    featured: true,
  },
  {
    id: 'crypto-bnb',
    name: 'bnb',
    author: 'BNB Chain',
    authorHandle: '@bnbchain',
    tag: 'Skill',
    category: 'tools',
    description: 'BNB Smart Chain operations. BEP-20 tokens, staking, and opBNB L2 interactions.',
    downloads: 23400,
    stars: 1080,
    version: '2.0.0',
    installCommand: '> install the bnb skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bnb',
    usageExample: '> interact with BSC\n> manage BEP-20 tokens\n> bridge to opBNB',
    detailedDescription: 'BNB Chain integration. Interact with BNB Smart Chain for DeFi and tokens, manage BEP-20 assets, stake BNB for validation rewards, and bridge to opBNB L2.',
  },
  {
    id: 'bnb-official-mcp',
    name: 'bnb-official-mcp',
    author: 'BNB Chain',
    authorHandle: '@bnbchain',
    tag: 'Skill',
    category: 'tools',
    description: 'Official BNB Chain MCP server. Model Context Protocol for BSC data access and transaction execution.',
    downloads: 8700,
    stars: 400,
    version: '1.0.0',
    installCommand: '> install the bnb-official-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bnb-official-mcp',
    usageExample: '> connect MCP to BSC\n> query BNB Chain data\n> execute via MCP',
    detailedDescription: 'Official BNB Chain Model Context Protocol server. Expose BSC blockchain data and transaction capabilities to AI models via standardized MCP interfaces.',
  },
  {
    id: 'bnbchain-mcp-agent',
    name: 'bnbchain-mcp-agent',
    author: 'BNB Chain',
    authorHandle: '@bnbchain',
    tag: 'Skill',
    category: 'tools',
    description: 'BNB Chain MCP agent wrapper. Agent-native access to BSC through Model Context Protocol with authentication.',
    downloads: 6200,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the bnbchain-mcp-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bnbchain-mcp-agent',
    usageExample: '> setup BNB MCP agent\n> authenticate with BSC\n> execute agent operations',
    detailedDescription: 'Agent wrapper for BNB Chain MCP. Authenticate agents with BNB Chain, execute authenticated operations, and manage agent permissions for BSC data access.',
  },
  {
    id: 'bnbchain-mcp',
    name: 'bnbchain-mcp',
    author: 'BNB Chain',
    authorHandle: '@bnbchain',
    tag: 'Skill',
    category: 'tools',
    description: 'BNB Chain MCP core. Raw Model Context Protocol implementation for BSC blockchain access.',
    downloads: 5400,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the bnbchain-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bnbchain-mcp',
    usageExample: '> initialize BNB MCP\n> query block data\n> submit transaction',
    detailedDescription: 'Core Model Context Protocol implementation for BNB Smart Chain. Query blockchain state, submit transactions, and manage BSC-specific data formats via MCP.',
  },
  {
    id: 'crypto-cardano',
    name: 'cardano',
    author: 'Cardano',
    authorHandle: '@cardano',
    tag: 'Skill',
    category: 'tools',
    description: 'Cardano blockchain operations. Transaction building, UTxO management, Plutus contract interaction, and governance voting.',
    downloads: 18600,
    stars: 890,
    version: '2.0.0',
    installCommand: '> install the cardano skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/cardano',
    usageExample: '> build Cardano tx\n> interact with Plutus\n> vote on governance',
    detailedDescription: 'Cardano blockchain integration. Build and sign transactions, manage UTxOs, interact with Plutus smart contracts, participate in Catalyst governance voting, and query the Cardano DB-Sync database.',
    featured: true,
  },
  {
    id: 'celo-official-agent-skills',
    name: 'celo-official-agent-skills',
    author: 'Celo',
    authorHandle: '@celo',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Celo agent toolkit. Celo EVM interactions, stablecoin transfers, and social impact verification.',
    downloads: 7600,
    stars: 350,
    version: '1.0.0',
    installCommand: '> install the celo-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/celo-official-agent-skills',
    usageExample: '> interact with Celo EVM\n> transfer cUSD\n> verify social impact',
    detailedDescription: 'Official Celo agent skills for EVM-compatible interactions. Transfer Celo stablecoins (cUSD, cEUR), verify social impact attestations, and manage Celo identity mappings.',
  },
  {
    id: 'chainlink-functions-agent',
    name: 'chainlink-functions-agent',
    author: 'Chainlink',
    authorHandle: '@chainlink',
    tag: 'Skill',
    category: 'tools',
    description: 'Chainlink Functions integration. Serverless Web3 compute, custom API consumption, and decentralized oracle logic.',
    downloads: 19800,
    stars: 940,
    version: '2.0.0',
    installCommand: '> install the chainlink-functions-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/chainlink-functions-agent',
    usageExample: '> execute Chainlink Function\n> consume custom API\n> build oracle logic',
    detailedDescription: 'Chainlink Functions serverless compute integration. Execute JavaScript/TypeScript logic in a decentralized manner, consume any API, and return computed results on-chain for smart contract consumption.',
    featured: true,
  },
  {
    id: 'chainlink-official-agent-skills',
    name: 'chainlink-official-agent-skills',
    author: 'Chainlink',
    authorHandle: '@chainlink',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Chainlink agent skills. Price feeds, VRF, CCIP, Automation, and Proof of Reserve for agent decision-making.',
    downloads: 23400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the chainlink-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/chainlink-official-agent-skills',
    usageExample: '> query price feed\n> request VRF randomness\n> send CCIP message',
    detailedDescription: 'Official Chainlink agent toolkit. Access price feeds for market data, request verifiable randomness via VRF, send cross-chain messages with CCIP, schedule automation, and verify reserves.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-cosmos',
    name: 'cosmos',
    author: 'Cosmos',
    authorHandle: '@cosmos',
    tag: 'Skill',
    category: 'tools',
    description: 'Cosmos SDK and IBC operations. Chain interaction, cross-chain messaging, and validator management.',
    downloads: 16700,
    stars: 780,
    version: '2.0.0',
    installCommand: '> install the cosmos skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/cosmos',
    usageExample: '> interact with Cosmos chain\n> send IBC transfer\n> manage validator',
    detailedDescription: 'Cosmos ecosystem integration. Interact with any Cosmos SDK chain, send IBC cross-chain transfers, manage validator nodes, delegate staking tokens, and query chain governance proposals.',
  },
  {
    id: 'crypto-ethereum',
    name: 'ethereum',
    author: 'Ethereum',
    authorHandle: '@ethereum',
    tag: 'Skill',
    category: 'tools',
    description: 'Ethereum L1 operations. Transaction execution, contract interaction, event monitoring, and ENS resolution.',
    downloads: 52100,
    stars: 2680,
    version: '3.0.0',
    installCommand: '> install the ethereum skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/ethereum',
    usageExample: '> execute Ethereum tx\n> interact with contract\n> resolve ENS name',
    detailedDescription: 'Core Ethereum L1 integration. Execute transactions, interact with smart contracts, monitor contract events via WebSocket/IPC, resolve ENS names, and query historical blockchain data.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-ethereum-jsonrpc',
    name: 'ethereum-jsonrpc',
    author: 'Ethereum',
    authorHandle: '@ethereum',
    tag: 'Skill',
    category: 'tools',
    description: 'Ethereum JSON-RPC interface. Direct RPC calls, batch requests, and custom method execution.',
    downloads: 19800,
    stars: 920,
    version: '2.0.0',
    installCommand: '> install the ethereum-jsonrpc skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/ethereum-jsonrpc',
    usageExample: '> send JSON-RPC call\n> execute batch requests\n> call custom method',
    detailedDescription: 'Direct Ethereum JSON-RPC access. Send individual and batched RPC requests, execute custom methods, handle responses with type safety, and manage connection pooling across multiple nodes.',
  },
  {
    id: 'crypto-hedera',
    name: 'hedera',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'tools',
    description: 'Hedera Hashgraph operations. HBAR transfers, consensus service, file service, and smart contract deployment.',
    downloads: 11200,
    stars: 520,
    version: '2.0.0',
    installCommand: '> install the hedera skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/hedera',
    usageExample: '> transfer HBAR\n> submit to consensus\n> deploy smart contract',
    detailedDescription: 'Hedera Hashgraph integration. Transfer HBAR, submit messages to the Hedera Consensus Service, manage file storage, and deploy Solidity smart contracts to Hedera EVM.',
  },
  {
    id: 'hedera-official-agent-kit-js',
    name: 'hedera-official-agent-kit-js',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Hedera agent kit for JavaScript. Complete toolkit for building agents on Hedera Hashgraph.',
    downloads: 7800,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the hedera-official-agent-kit-js skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/hedera-official-agent-kit-js',
    usageExample: '> initialize Hedera agent\n> execute HCS message\n> manage token service',
    detailedDescription: 'Official Hedera agent development kit for JavaScript/TypeScript. Build agents with full access to Hedera Consensus Service, Token Service, File Service, and Smart Contract Service.',
  },
  {
    id: 'hedera-tx-builder',
    name: 'hedera-tx-builder',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'tools',
    description: 'Hedera transaction builder. Construct, sign, and execute complex multi-service transactions.',
    downloads: 5400,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the hedera-tx-builder skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/hedera-tx-builder',
    usageExample: '> build Hedera tx\n> sign multi-service tx\n> execute atomically',
    detailedDescription: 'Hedera atomic transaction builder. Construct transactions spanning multiple services (Crypto, Consensus, File, Token, Smart Contract), sign with threshold keys, and execute atomically.',
  },
  {
    id: 'helius-official-core-ai',
    name: 'helius-official-core-ai',
    author: 'Helius',
    authorHandle: '@heliuslabs',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Helius AI toolkit for Solana. RPC optimization, NFT APIs, Webhooks, and transaction parsing.',
    downloads: 24500,
    stars: 1180,
    version: '1.0.0',
    installCommand: '> install the helius-official-core-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/helius-official-core-ai',
    usageExample: '> query optimized Solana RPC\n> parse transaction history\n> setup NFT webhook',
    detailedDescription: 'Official Helius AI integration for Solana. Access optimized RPC endpoints, query NFT metadata and ownership, configure real-time webhooks, and parse complex transaction histories.',
    featured: true,
    trending: true,
  },
  {
    id: 'icp-official-ic-skills',
    name: 'icp-official-ic-skills',
    author: 'DFINITY',
    authorHandle: '@dfinity',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Internet Computer agent skills. Canister interaction, cycles management, and IC-native authentication.',
    downloads: 9200,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the icp-official-ic-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/icp-official-ic-skills',
    usageExample: '> interact with canister\n> manage cycles\n> authenticate with II',
    detailedDescription: 'Official Internet Computer (ICP) agent toolkit. Interact with canisters in Motoko and Rust, manage cycle balances and top-ups, and authenticate users with Internet Identity.',
  },
  {
    id: 'crypto-injective-hub',
    name: 'injective-hub',
    author: 'Injective',
    authorHandle: '@injective',
    tag: 'Skill',
    category: 'tools',
    description: 'Injective Hub operations. Derivatives trading, spot markets, staking INJ, and governance proposals.',
    downloads: 11200,
    stars: 520,
    version: '1.5.0',
    installCommand: '> install the injective-hub skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/injective-hub',
    usageExample: '> trade on Injective\n> stake INJ tokens\n> vote on proposal',
    detailedDescription: 'Injective Hub integration for the Layer-1 DeFi protocol. Trade derivatives and spot markets, stake INJ for rewards, create and vote on governance proposals, and manage portfolio across markets.',
  },
  {
    id: 'crypto-lightning-commerce',
    name: 'lightning-commerce',
    author: 'Lightning Labs',
    authorHandle: '@lightning',
    tag: 'Skill',
    category: 'tools',
    description: 'Bitcoin Lightning Network commerce toolkit. Payment processing, invoice generation, and channel liquidity management.',
    downloads: 7800,
    stars: 360,
    version: '1.2.0',
    installCommand: '> install the lightning-commerce skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lightning-commerce',
    usageExample: '> generate Lightning invoice\n> process payment\n> manage channel liquidity',
    detailedDescription: 'Bitcoin Lightning Network commerce integration. Generate payment invoices, process instant Bitcoin payments, manage channel liquidity for optimal routing, and track payment analytics.',
  },
  {
    id: 'crypto-lightning-mcp',
    name: 'lightning-mcp',
    author: 'Lightning Labs',
    authorHandle: '@lightning',
    tag: 'Skill',
    category: 'tools',
    description: 'Lightning Network Model Context Protocol. MCP server for Bitcoin Lightning node data and payment operations.',
    downloads: 4500,
    stars: 200,
    version: '1.0.0',
    installCommand: '> install the lightning-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lightning-mcp',
    usageExample: '> connect Lightning MCP\n> query node data\n> execute payment via MCP',
    detailedDescription: 'Bitcoin Lightning Network Model Context Protocol server. Expose Lightning node data, payment channels, and invoice operations to AI agents via standardized MCP interfaces.',
  },
  {
    id: 'crypto-monad',
    name: 'monad',
    author: 'Monad',
    authorHandle: '@monad_xyz',
    tag: 'Skill',
    category: 'tools',
    description: 'Monad blockchain operations. High-performance EVM execution, parallel transaction processing, and state management.',
    downloads: 12400,
    stars: 580,
    version: '1.0.0',
    installCommand: '> install the monad skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/monad',
    usageExample: '> interact with Monad\n> execute parallel tx\n> manage Monad state',
    detailedDescription: 'Monad high-performance EVM blockchain integration. Execute transactions with parallel processing, manage state efficiently, and interact with Monad\'s optimized EVM-compatible execution environment.',
    trending: true,
  },
  {
    id: 'crypto-near',
    name: 'near',
    author: 'NEAR Protocol',
    authorHandle: '@nearprotocol',
    tag: 'Skill',
    category: 'tools',
    description: 'NEAR Protocol operations. Account management, contract calls, staking, and NEAR AI integration.',
    downloads: 19800,
    stars: 920,
    version: '2.0.0',
    installCommand: '> install the near skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/near',
    usageExample: '> manage NEAR account\n> call smart contract\n> stake NEAR tokens',
    detailedDescription: 'NEAR Protocol integration. Manage human-readable accounts, call Rust/AssemblyScript contracts, stake NEAR for validation rewards, and integrate with NEAR AI for agent capabilities.',
    featured: true,
  },
  {
    id: 'crypto-near-cli-tools',
    name: 'near-cli-tools',
    author: 'NEAR Protocol',
    authorHandle: '@nearprotocol',
    tag: 'Skill',
    category: 'tools',
    description: 'NEAR CLI toolkit for agents. Command-line operations, key management, and deployment automation.',
    downloads: 6200,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the near-cli-tools skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/near-cli-tools',
    usageExample: '> use NEAR CLI from agent\n> manage access keys\n> auto-deploy contract',
    detailedDescription: 'NEAR command-line interface toolkit for autonomous agents. Execute CLI commands programmatically, manage access keys, automate contract deployment, and handle configuration profiles.',
  },
  {
    id: 'crypto-nexus-node-deploy',
    name: 'nexus-node-deploy',
    author: 'Nexus',
    authorHandle: '@nexus',
    tag: 'Skill',
    category: 'tools',
    description: 'Nexus blockchain node deployment. Validator setup, network configuration, and node monitoring.',
    downloads: 3400,
    stars: 150,
    version: '1.0.0',
    installCommand: '> install the nexus-node-deploy skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/nexus-node-deploy',
    usageExample: '> deploy Nexus node\n> configure validator\n> monitor node health',
    detailedDescription: 'Nexus blockchain node deployment and management. Set up validator nodes, configure network parameters, monitor node health and sync status, and manage consensus participation.',
  },
  {
    id: 'crypto-nexusnode',
    name: 'nexusnode',
    author: 'Nexus',
    authorHandle: '@nexus',
    tag: 'Skill',
    category: 'tools',
    description: 'Nexus node management core. RPC access, block queries, and transaction submission for Nexus chain.',
    downloads: 2800,
    stars: 120,
    version: '1.0.0',
    installCommand: '> install the nexusnode skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/nexusnode',
    usageExample: '> connect to Nexus RPC\n> query Nexus blocks\n> submit Nexus tx',
    detailedDescription: 'Core Nexus blockchain node interface. Connect to Nexus RPC endpoints, query block and transaction data, submit signed transactions, and monitor network activity.',
  },
  {
    id: 'crypto-nodesentinel',
    name: 'nodesentinel',
    author: 'NodeSentinel',
    authorHandle: '@nodesentinel',
    tag: 'Skill',
    category: 'tools',
    description: 'Multi-chain node monitoring and alerting. Health checks, sync tracking, and performance analytics.',
    downloads: 5600,
    stars: 260,
    version: '1.0.0',
    installCommand: '> install the nodesentinel skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/nodesentinel',
    usageExample: '> monitor node health\n> track sync progress\n> alert on failure',
    detailedDescription: 'Universal blockchain node monitoring. Track health metrics across multiple chains, monitor sync progress, detect performance degradation, and send alerts via multiple channels.',
  },
  {
    id: 'crypto-polkadot',
    name: 'polkadot',
    author: 'Polkadot',
    authorHandle: '@polkadot',
    tag: 'Skill',
    category: 'tools',
    description: 'Polkadot and parachain operations. DOT staking, XCM messaging, crowdloan participation, and Substrate interaction.',
    downloads: 15600,
    stars: 720,
    version: '2.0.0',
    installCommand: '> install the polkadot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/polkadot',
    usageExample: '> stake DOT\n> send XCM message\n> interact with parachain',
    detailedDescription: 'Polkadot ecosystem integration. Stake DOT for nomination rewards, send cross-consensus messages (XCM) between parachains, participate in crowdloans, and interact with Substrate-based chains.',
    featured: true,
  },
  {
    id: 'crypto-polygon',
    name: 'polygon',
    author: 'Polygon',
    authorHandle: '@0xpolygon',
    tag: 'Skill',
    category: 'tools',
    description: 'Polygon PoS and zkEVM operations. Transaction execution, bridge operations, and CDK chain deployment.',
    downloads: 28900,
    stars: 1340,
    version: '2.5.0',
    installCommand: '> install the polygon skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/polygon',
    usageExample: '> interact with Polygon PoS\n> bridge to zkEVM\n> deploy CDK chain',
    detailedDescription: 'Polygon ecosystem integration. Execute transactions on Polygon PoS, bridge assets to zkEVM, interact with Polygon CDK chains, and manage POL token staking and delegation.',
    featured: true,
  },
  {
    id: 'quicknode-official-blockchain-skills',
    name: 'quicknode-official-blockchain-skills',
    author: 'QuickNode',
    authorHandle: '@quicknode',
    tag: 'Skill',
    category: 'tools',
    description: 'Official QuickNode blockchain skills. Multi-chain RPC access, Streams API, and Token API for 15+ networks.',
    downloads: 32100,
    stars: 1520,
    version: '1.0.0',
    installCommand: '> install the quicknode-official-blockchain-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/quicknode-official-blockchain-skills',
    usageExample: '> access multi-chain RPC\n> setup real-time Streams\n> query Token API',
    detailedDescription: 'Official QuickNode blockchain toolkit for agents. Access high-performance RPC across 15+ networks, consume real-time data with Streams API, and query token metadata with Token API.',
    featured: true,
    trending: true,
  },
  {
    id: 'sendai-official-solana-skills',
    name: 'sendai-official-solana-skills',
    author: 'SendAI',
    authorHandle: '@sendaifun',
    tag: 'Skill',
    category: 'tools',
    description: 'Official SendAI Solana agent skills. Solana-native agent operations, transaction building, and marketplace interactions.',
    downloads: 18700,
    stars: 870,
    version: '1.0.0',
    installCommand: '> install the sendai-official-solana-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sendai-official-solana-skills',
    usageExample: '> build Solana tx\n> interact with marketplace\n> manage agent on Solana',
    detailedDescription: 'Official SendAI Solana agent toolkit. Build and execute Solana transactions, interact with NFT and DeFi marketplaces, manage agent identities on-chain, and leverage Solana\'s high throughput.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-solana',
    name: 'solana',
    author: 'Solana',
    authorHandle: '@solana',
    tag: 'Skill',
    category: 'tools',
    description: 'Solana blockchain operations. Transaction building, SPL token management, program interaction, and staking.',
    downloads: 41200,
    stars: 1980,
    version: '3.0.0',
    installCommand: '> install the solana skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/solana',
    usageExample: '> build Solana tx\n> manage SPL tokens\n> interact with program',
    detailedDescription: 'Core Solana blockchain integration. Build and sign transactions, manage SPL tokens and NFTs, interact with Solana programs (smart contracts), stake SOL for validation rewards, and query account data.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-solana-starter-agent',
    name: 'solana-starter-agent',
    author: 'Solana',
    authorHandle: '@solana',
    tag: 'Skill',
    category: 'tools',
    description: 'Solana starter agent template. Agent scaffolding, wallet setup, and first on-chain interaction on Solana.',
    downloads: 12400,
    stars: 580,
    version: '1.0.0',
    installCommand: '> install the solana-starter-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/solana-starter-agent',
    usageExample: '> initialize Solana agent\n> setup wallet\n> execute first tx',
    detailedDescription: 'Solana agent starter template. Scaffold a new agent project with Solana integration, configure wallets and RPC endpoints, and execute the first on-chain transaction with guided setup.',
  },
  {
    id: 'crypto-solidity',
    name: 'solidity',
    author: 'Ethereum',
    authorHandle: '@ethereum',
    tag: 'Skill',
    category: 'tools',
    description: 'Solidity contract development toolkit. Compilation, testing, deployment, and verification across EVM chains.',
    downloads: 35600,
    stars: 1720,
    version: '2.0.0',
    installCommand: '> install the solidity skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/solidity',
    usageExample: '> compile Solidity contract\n> run unit tests\n> deploy to EVM chain',
    detailedDescription: 'Solidity smart contract development toolkit. Compile contracts with multiple compiler versions, run comprehensive unit and integration tests, deploy to any EVM chain, and verify on explorers.',
    featured: true,
  },
  {
    id: 'crypto-starknet',
    name: 'starknet',
    author: 'Starknet',
    authorHandle: '@starknet',
    tag: 'Skill',
    category: 'tools',
    description: 'Starknet L2 operations. Cairo contract interaction, account abstraction, and STARK proof verification.',
    downloads: 15600,
    stars: 720,
    version: '2.0.0',
    installCommand: '> install the starknet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/starknet',
    usageExample: '> interact with Cairo contract\n> manage smart account\n> verify STARK proof',
    detailedDescription: 'Starknet Layer-2 integration. Interact with Cairo smart contracts, manage account abstraction wallets (ArgentX, Braavos), verify STARK proofs, and query L2 state via Starknet feeder gateway.',
    featured: true,
  },
  {
    id: 'crypto-stellar',
    name: 'stellar',
    author: 'Stellar',
    authorHandle: '@stellarorg',
    tag: 'Skill',
    category: 'tools',
    description: 'Stellar network operations. Asset issuance, path payments, anchors, and Soroban smart contracts.',
    downloads: 9800,
    stars: 460,
    version: '2.0.0',
    installCommand: '> install the stellar skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/stellar',
    usageExample: '> issue asset on Stellar\n> execute path payment\n> interact with Soroban',
    detailedDescription: 'Stellar blockchain integration. Issue custom assets, execute path payments for optimal exchange rates, interact with anchor services for fiat on/off ramps, and deploy Soroban smart contracts.',
  },
  {
    id: 'crypto-sui',
    name: 'sui',
    author: 'Sui',
    authorHandle: '@mysten_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Sui blockchain operations. Move object interaction, transaction building, staking, and kiosk operations.',
    downloads: 18700,
    stars: 870,
    version: '2.0.0',
    installCommand: '> install the sui skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sui',
    usageExample: '> interact with Move object\n> build Sui tx\n> stake SUI tokens',
    detailedDescription: 'Sui blockchain integration. Interact with Move objects, build programmable transactions, stake SUI for validator rewards, manage kiosk NFT trading, and query object ownership and events.',
    featured: true,
    trending: true,
  },
  {
    id: 'crypto-sui-move',
    name: 'sui-move',
    author: 'Sui',
    authorHandle: '@mysten_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Move language toolkit for Sui. Package development, compilation, testing, and on-chain publishing.',
    downloads: 11200,
    stars: 520,
    version: '1.5.0',
    installCommand: '> install the sui-move skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sui-move',
    usageExample: '> compile Move package\n> run Move tests\n> publish to Sui',
    detailedDescription: 'Move language development toolkit for Sui. Write, compile, and test Move packages, manage dependencies, simulate transactions locally, and publish packages to the Sui network.',
  },
  {
    id: 'crypto-sui-iconrpc',
    name: 'sui-iconrpc',
    author: 'Sui',
    authorHandle: '@mysten_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Sui IconRPC gateway. Custom RPC methods, batch queries, and optimized data access for Sui agents.',
    downloads: 4800,
    stars: 220,
    version: '1.0.0',
    installCommand: '> install the sui-iconrpc skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sui-iconrpc',
    usageExample: '> query via IconRPC\n> execute batch queries\n> access optimized data',
    detailedDescription: 'Sui IconRPC gateway for optimized data access. Execute custom RPC methods, send batch queries for efficiency, and access indexed Sui data optimized for agent consumption.',
  },
  {
    id: 'crypto-sui-agent-wallet',
    name: 'sui-agent-wallet',
    author: 'Sui',
    authorHandle: '@mysten_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Agent-native wallet for Sui. Programmable transaction blocks, multi-sig, and zkLogin authentication.',
    downloads: 7600,
    stars: 350,
    version: '1.0.0',
    installCommand: '> install the sui-agent-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sui-agent-wallet',
    usageExample: '> create agent wallet\n> build programmable tx\n> authenticate with zkLogin',
    detailedDescription: 'Agent-native wallet infrastructure for Sui. Build programmable transaction blocks, manage multi-signature configurations, and authenticate users with zkLogin for privacy-preserving access.',
  },
  {
    id: 'crypto-ton',
    name: 'ton',
    author: 'TON',
    authorHandle: '@ton_blockchain',
    tag: 'Skill',
    category: 'tools',
    description: 'The Open Network operations. TON contract interaction, Jetton token management, and DNS resolution.',
    downloads: 13400,
    stars: 620,
    version: '2.0.0',
    installCommand: '> install the ton skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/ton',
    usageExample: '> interact with TON contract\n> manage Jetton tokens\n> resolve TON DNS',
    detailedDescription: 'The Open Network (TON) integration. Interact with FunC/Tact smart contracts, manage Jetton tokens and NFTs, resolve .ton DNS names, and handle wallet contracts with seqno management.',
  },
  {
    id: 'crypto-tron',
    name: 'tron',
    author: 'TRON',
    authorHandle: '@trondao',
    tag: 'Skill',
    category: 'tools',
    description: 'TRON network operations. TRC-20 token transfers, smart contract calls, and energy/bandwidth management.',
    downloads: 15600,
    stars: 720,
    version: '2.0.0',
    installCommand: '> install the tron skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/tron',
    usageExample: '> transfer TRC-20 tokens\n> call TRON contract\n> manage energy/bandwidth',
    detailedDescription: 'TRON blockchain integration. Transfer TRC-20 and TRC-10 tokens, interact with TVM smart contracts, manage energy and bandwidth resources, and query TRON account and transaction data.',
  },
  {
    id: 'tron-contract-analysis',
    name: 'tron-contract-analysis',
    author: 'TRON',
    authorHandle: '@trondao',
    tag: 'Skill',
    category: 'tools',
    description: 'TRON smart contract analysis. Security auditing, bytecode inspection, and vulnerability detection for TVM contracts.',
    downloads: 4800,
    stars: 220,
    version: '1.0.0',
    installCommand: '> install the tron-contract-analysis skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/tron-contract-analysis',
    usageExample: '> audit TRON contract\n> inspect TVM bytecode\n> detect vulnerabilities',
    detailedDescription: 'TRON smart contract security analysis. Audit TVM contract bytecode, detect common vulnerabilities, analyze contract call graphs, and generate security reports for TRON-based projects.',
  },
  {
    id: 'worldcoin-official-agentkit',
    name: 'worldcoin-official-agentkit',
    author: 'Worldcoin',
    authorHandle: '@worldcoin',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Worldcoin agent kit. World ID verification, proof of personhood, and iris-code authentication for agents.',
    downloads: 11200,
    stars: 520,
    version: '1.0.0',
    installCommand: '> install the worldcoin-official-agentkit skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/worldcoin-official-agentkit',
    usageExample: '> verify with World ID\n> prove personhood\n> authenticate agent',
    detailedDescription: 'Official Worldcoin integration for agents. Verify human users with World ID, request proof of personhood, and integrate iris-code authentication for sybil-resistant agent operations.',
    featured: true,
  },
  {
    id: 'crypto-xrp',
    name: 'xrp',
    author: 'Ripple',
    authorHandle: '@ripple',
    tag: 'Skill',
    category: 'tools',
    description: 'XRP Ledger operations. Payment channels, escrow, multi-signing, and AMM pool management.',
    downloads: 19800,
    stars: 920,
    version: '2.0.0',
    installCommand: '> install the xrp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/xrp',
    usageExample: '> send XRP payment\n> create payment channel\n> manage AMM pool',
    detailedDescription: 'XRP Ledger integration. Send payments, create and claim payment channels, manage time-locked escrows, configure multi-signature accounts, and interact with the native AMM for automated market making.',
    featured: true,
  },
  {
    id: 'crypto-xrp-tx-builder',
    name: 'xrp-tx-builder',
    author: 'Ripple',
    authorHandle: '@ripple',
    tag: 'Skill',
    category: 'tools',
    description: 'XRP Ledger transaction builder. Complex transaction construction, multi-operation batches, and fee optimization.',
    downloads: 6200,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the xrp-tx-builder skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/xrp-tx-builder',
    usageExample: '> build complex XRP tx\n> batch multiple operations\n> optimize fees',
    detailedDescription: 'XRP Ledger advanced transaction builder. Construct complex transactions with multiple operations, batch related payments and trust line modifications, and optimize fees based on network load.',
  },
  {
    id: 'blockscout-official-agent-skills',
    name: 'blockscout-official-agent-skills',
    author: 'Blockscout',
    authorHandle: '@blockscout',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Blockscout agent skills. Block explorer data access, contract verification, and API analytics for 500+ chains.',
    downloads: 13400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the blockscout-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/blockscout-official-agent-skills',
    usageExample: '> query Blockscout API\n> verify contract\n> access chain analytics',
    detailedDescription: 'Official Blockscout block explorer integration. Query transaction and contract data across 500+ chains, verify smart contracts, access API analytics, and monitor real-time chain activity.',
  },
  {
    id: 'aelf-official-skills',
    name: 'aelf-official-skills',
    author: 'aelf',
    authorHandle: '@aelfblockchain',
    tag: 'Skill',
    category: 'tools',
    description: 'Official aelf blockchain skills. Sidechain interaction, AEDPoS consensus, and cross-chain token transfers.',
    downloads: 4800,
    stars: 220,
    version: '1.0.0',
    installCommand: '> install the aelf-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/aelf-official-skills',
    usageExample: '> interact with aelf sidechain\n> manage AEDPoS staking\n> execute cross-chain transfer',
    detailedDescription: 'Official aelf blockchain integration. Interact with aelf sidechains, participate in AEDPoS consensus staking, execute cross-chain token transfers between mainchain and sidechains, and manage resource tokens.',
  },

  // ===== Trading / Automation =====
  {
    id: 'crypto-agent-blackrock',
    name: 'agent-blackrock',
    author: 'BlackRock',
    authorHandle: '@blackrock',
    tag: 'Skill',
    category: 'tools',
    description: 'Institutional-grade portfolio management agent. Risk-adjusted allocation, factor modeling, and regulatory reporting.',
    downloads: 8700,
    stars: 390,
    version: '1.0.0',
    installCommand: '> install the agent-blackrock skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/agent-blackrock',
    usageExample: '> optimize portfolio allocation\n> run factor model\n> generate compliance report',
    detailedDescription: 'Institutional-grade portfolio management for agents. Apply Modern Portfolio Theory, execute factor-based allocation models, and generate regulatory-compliant reports with full audit trails.',
  },
  {
    id: 'crypto-auto-trading-strategy',
    name: 'auto-trading-strategy',
    author: 'AutoTrader',
    authorHandle: '@autotrader',
    tag: 'Skill',
    category: 'tools',
    description: 'Automated trading strategy engine. Backtesting, signal generation, and execution across DEX and CEX venues.',
    downloads: 15600,
    stars: 720,
    version: '2.0.0',
    installCommand: '> install the auto-trading-strategy skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/auto-trading-strategy',
    usageExample: '> backtest strategy\n> generate trade signal\n> execute across venues',
    detailedDescription: 'Automated trading strategy framework. Backtest strategies on historical data, generate real-time signals from technical and on-chain indicators, and execute across DEX and CEX venues with slippage protection.',
    trending: true,
  },
  {
    id: 'crypto-autopilot-brokerage',
    name: 'autopilot-brokerage',
    author: 'Autopilot',
    authorHandle: '@autopilot',
    tag: 'Skill',
    category: 'tools',
    description: 'Autonomous brokerage operations. Order routing, smart order types, and multi-venue execution with cost optimization.',
    downloads: 9200,
    stars: 410,
    version: '1.5.0',
    installCommand: '> install the autopilot-brokerage skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/autopilot-brokerage',
    usageExample: '> route order optimally\n> execute smart order\n> optimize execution cost',
    detailedDescription: 'Autonomous brokerage execution engine. Route orders across multiple venues for best price, execute smart order types (TWAP, VWAP, implementation shortfall), and optimize total execution cost.',
  },
  {
    id: 'crypto-autopilot-solana-trader',
    name: 'autopilot-solana-trader',
    author: 'Autopilot',
    authorHandle: '@autopilot',
    tag: 'Skill',
    category: 'tools',
    description: 'Solana-native autonomous trader. Jupiter routing, Jito bundle execution, and MEV-aware trading on Solana.',
    downloads: 11200,
    stars: 520,
    version: '1.0.0',
    installCommand: '> install the autopilot-solana-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/autopilot-solana-trader',
    usageExample: '> trade via Jupiter\n> execute Jito bundle\n> avoid MEV extraction',
    detailedDescription: 'Solana-specific autonomous trading. Route trades through Jupiter for optimal pricing, execute Jito bundles for atomic transactions, and implement MEV-aware strategies to minimize value extraction.',
  },
  {
    id: 'crypto-ave-trading-agent',
    name: 'ave-trading-agent',
    author: 'AveTrader',
    authorHandle: '@avetrader',
    tag: 'Skill',
    category: 'tools',
    description: 'Avenue trading agent with multi-strategy support. Mean reversion, momentum, and arbitrage across spot and perp markets.',
    downloads: 6800,
    stars: 310,
    version: '1.2.0',
    installCommand: '> install the ave-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ave-trading-agent',
    usageExample: '> run mean reversion strategy\n> execute momentum trade\n> spot arbitrage opportunity',
    detailedDescription: 'Multi-strategy trading agent supporting mean reversion, momentum, and arbitrage strategies. Operates across spot and perpetual markets with automatic strategy selection based on market regime.',
  },
  {
    id: 'crypto-baseflow-agent',
    name: 'baseflow-agent',
    author: 'BaseFlow',
    authorHandle: '@baseflow',
    tag: 'Skill',
    category: 'tools',
    description: 'On-chain flow analysis agent. Detect smart money movements, whale alerts, and funding rate anomalies on Base.',
    downloads: 7800,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the baseflow-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/baseflow-agent',
    usageExample: '> detect smart money flow\n> alert on whale movement\n> monitor funding rates',
    detailedDescription: 'On-chain flow analysis for Base. Detect smart money wallet movements, generate whale alerts for large transfers, monitor funding rate anomalies, and track exchange inflow/outflow patterns.',
  },
  {
    id: 'crypto-dca-automation-engine',
    name: 'dca-automation-engine',
    author: 'DCA Engine',
    authorHandle: '@dcaengine',
    tag: 'Skill',
    category: 'tools',
    description: 'Dollar-cost averaging automation engine. Schedule recurring purchases, rebalance allocations, and tax-aware harvesting.',
    downloads: 11200,
    stars: 520,
    version: '2.0.0',
    installCommand: '> install the dca-automation-engine skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/dca-automation-engine',
    usageExample: '> schedule weekly DCA\n> auto-rebalance allocation\n> harvest tax losses',
    detailedDescription: 'Advanced dollar-cost averaging automation. Schedule recurring purchases at optimal intervals, automatically rebalance allocations based on drift, and implement tax-loss harvesting strategies.',
  },
  {
    id: 'crypto-dca-automation',
    name: 'dca-automation',
    author: 'DCA Bot',
    authorHandle: '@dcabot',
    tag: 'Skill',
    category: 'tools',
    description: 'Simple DCA automation bot. Recurring buys, price-target triggered purchases, and basic portfolio tracking.',
    downloads: 15600,
    stars: 720,
    version: '1.5.0',
    installCommand: '> install the dca-automation skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/dca-automation',
    usageExample: '> setup daily DCA\n> trigger buy at target\n> track portfolio growth',
    detailedDescription: 'Simple DCA automation for retail agents. Configure recurring purchase schedules, set price targets for triggered buys, and track portfolio growth with basic analytics and reporting.',
    trending: true,
  },
  {
    id: 'crypto-debot-trading-agent',
    name: 'debot-trading-agent',
    author: 'DeBot',
    authorHandle: '@debot',
    tag: 'Skill',
    category: 'tools',
    description: 'DeBot autonomous trading agent. Multi-exchange arbitrage, grid trading, and delta-neutral strategies.',
    downloads: 6200,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the debot-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/debot-trading-agent',
    usageExample: '> execute cross-exchange arb\n> run grid strategy\n> maintain delta-neutral',
    detailedDescription: 'DeBot multi-strategy trading agent. Execute cross-exchange arbitrage opportunities, run automated grid trading strategies, and maintain delta-neutral positions with dynamic hedging.',
  },
  {
    id: 'crypto-engr-mev-sniping',
    name: 'engr-mev-sniping',
    author: 'ENGR',
    authorHandle: '@engr',
    tag: 'Skill',
    category: 'tools',
    description: 'MEV sniping and protection toolkit. Sandwich detection, frontrunning simulation, and private mempool submission.',
    downloads: 4800,
    stars: 220,
    version: '1.0.0',
    installCommand: '> install the engr-mev-sniping skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/engr-mev-sniping',
    usageExample: '> detect sandwich attack\n> simulate frontrun\n> submit to private mempool',
    detailedDescription: 'MEV analysis and protection toolkit. Detect sandwich attack patterns, simulate frontrunning scenarios, and submit transactions through private mempools (Flashbots, MEV-Share) for protection.',
  },
  {
    id: 'crypto-cryptocom-official-agent-trading',
    name: 'cryptocom-official-agent-trading',
    author: 'Crypto.com',
    authorHandle: '@cryptocom',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Crypto.com agent trading skills. Exchange API access, spot/perp trading, and staking automation.',
    downloads: 18700,
    stars: 870,
    version: '1.0.0',
    installCommand: '> install the cryptocom-official-agent-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/cryptocom-official-agent-trading',
    usageExample: '> access Crypto.com API\n> execute spot trade\n> auto-stake CRO',
    detailedDescription: 'Official Crypto.com exchange integration for agents. Access spot and perpetual trading APIs, automate staking and rewards, manage sub-accounts, and query market data with institutional-grade feeds.',
  },
  {
    id: 'coinpaprika-official-claude-marketplace',
    name: 'coinpaprika-official-claude-marketplace',
    author: 'CoinPaprika',
    authorHandle: '@coinpaprika',
    tag: 'Skill',
    category: 'tools',
    description: 'Official CoinPaprika marketplace skills. Market data, DexPaprika DEX analytics, and portfolio tracking for Claude agents.',
    downloads: 12400,
    stars: 580,
    version: '1.0.0',
    installCommand: '> install the coinpaprika-official-claude-marketplace skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/coinpaprika-official-claude-marketplace',
    usageExample: '> query market data\n> access DexPaprika analytics\n> track portfolio',
    detailedDescription: 'Official CoinPaprika and DexPaprika integration. Query comprehensive market data, access DEX analytics across chains, track portfolio performance, and integrate with Claude marketplace for enhanced AI trading insights.',
  },

  // ===== Social / Other =====
  {
    id: 'crypto-mute-ai-agent',
    name: 'mute-ai-agent',
    author: 'Mute',
    authorHandle: '@mute',
    tag: 'Skill',
    category: 'other',
    description: 'Silent autonomous agent. Stealth operations, minimal on-chain footprint, and privacy-preserving computation.',
    downloads: 3400,
    stars: 150,
    version: '0.5.0',
    installCommand: '> install the mute-ai-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/mute-ai-agent',
    usageExample: '> execute stealth operation\n> minimize on-chain footprint\n> preserve privacy',
    detailedDescription: 'Stealth-mode autonomous agent designed for minimal on-chain footprint. Execute operations through privacy-preserving computation, use ephemeral addresses, and avoid address clustering for sensitive tasks.',
  },
  {
    id: 'crypto-real-thrill-agent',
    name: 'real-thrill-agent',
    author: 'RealThrill',
    authorHandle: '@realthrill',
    tag: 'Skill',
    category: 'other',
    description: 'Gamified agent with real-world impact. Complete challenges, earn rewards, and contribute to verified outcomes.',
    downloads: 4200,
    stars: 190,
    version: '1.0.0',
    installCommand: '> install the real-thrill-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/ai-crypto/real-thrill-agent',
    usageExample: '> complete challenge\n> earn reward\n> verify real-world outcome',
    detailedDescription: 'Gamified autonomous agent that combines on-chain challenges with real-world impact. Complete tasks, earn tokenized rewards, and contribute to verified social and environmental outcomes.',
  },
];